// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PageTitleCount from "@awc/App/Components/Common/PageTitleCount";
import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC, useContext } from "react";

const OrderHistoryTitleCount: FC<WidgetProps> = () => {
    const ordersDataView = useContext(OrdersDataViewContext);
    let totalItemCount = 0;

    if (ordersDataView.value && ordersDataView.pagination) {
        totalItemCount = ordersDataView.pagination.totalItemCount;
    }

    return <PageTitleCount countNumber={totalItemCount} noun="Order" showCountOnly={true} />;
};

const widgetModule: WidgetModule = {
    component: OrderHistoryTitleCount,
    definition: {
        group: "Order History",
        displayName: "Title Count",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
